import React from 'react';
import FlatButton from 'material-ui/FlatButton';

export const CancelButton = props => {
    const { handleClose = () => {}, reset, resetErrors = () => {}, style, clearAuthErrors = () => {}, customAction = () => {}, label='Cancel' } = props;
    return (
        <FlatButton
            label={label}
            disableTouchRipple={true}
            disableFocusRipple={true}
            onClick={(event)=>{
                handleClose();
                if(resetErrors && reset){
                    resetErrors(reset)
                    clearAuthErrors();
                } 
                customAction();
            }}
            style={{marginRight: 12, ...style}}
        />
    );
}

// export default CancelButton;

// import React from 'react';
// import styled from 'styled-components';

// export const CancelButton = styled.div`
//     display: flex; 
//     justify-content: space-between;
//     align-items: center; 
//     margin-bottom: 30px;
// `;


// WEBPACK FOOTER //
// ./src/js/components/Form/Buttons/CancelButton.jsx